module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_library.js
// module id = 715
// module chunks = 0 15 16 17 18